import { Button, Flex } from "@chakra-ui/react";
import {
  CAPITAL_AMOUNT_FIELD,
  STUB_CALCULATION,
} from "features/transactions/TransactionsViewTable/CalculationActions/constants";
import { useFundFamilyListSuspense } from "gen/endpoints/fund-family/fund-family";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SelectOption } from "shared/components/input/select/SelectOption";
import { SimpleSelect } from "shared/components/input/select/SimpleSelect";
import { useMaybernTableUIContext } from "shared/components/table/maybern/MaybernTableUIContext";

export const FundFamilySelect = ({
  fundFamilyIds,
  setFundFamilyIds,
  setTransactionCalculationId,
}: {
  fundFamilyIds: string[];
  setFundFamilyIds: (fundFamilyId: string[]) => void;
  setTransactionCalculationId: (calcId: string) => void;
}) => {
  const { t } = useTranslation(["common", "enums"]);
  const { data: fundFamilies } = useFundFamilyListSuspense();
  const { agGrid } = useMaybernTableUIContext();

  const resetCalculation = useCallback(() => {
    setTransactionCalculationId(STUB_CALCULATION.id);
    agGrid?.api.setColumnAggFunc(CAPITAL_AMOUNT_FIELD, "sum");
  }, [setTransactionCalculationId, agGrid]);

  const options = useMemo(
    () =>
      fundFamilies.map(({ id, name }) => (
        <SelectOption
          key={id}
          value={id!}
          rightChild={
            <Button
              onClick={(e) => {
                e.stopPropagation();
                resetCalculation();
                setFundFamilyIds([id!]);
              }}
              size="xs"
              variant="ghostDarken"
            >
              {t("common:only")}
            </Button>
          }
        >
          {name}
        </SelectOption>
      )),
    [fundFamilies, resetCalculation, setFundFamilyIds, t],
  );
  return (
    <Flex display="flex" mb="0" alignItems="center">
      <SimpleSelect
        defaultAllText={t("common:allFundFamilies")}
        size="sm"
        title={t("enums:FundFamilyEventSubTypeEnum.transaction_calculation")}
        value={fundFamilyIds}
        onChangeValue={(val) => {
          if (val.length !== 1) {
            // cant use calc with multiple/zero fund families
            resetCalculation();
          }
          setFundFamilyIds(val);
        }}
        isMulti={true}
        minWidth="275px"
        placeholder={t("common:selectFundFamilies")}
      >
        {options}
      </SimpleSelect>
    </Flex>
  );
};
